/**
 * Created by superman on 17/2/16.
 * http配置
 */
import axios from 'axios'
// axios 配置
axios.defaults.timeout = 50000
axios.defaults.baseURL =
  process.env.NODE_ENV === 'production'
    ? 'https://www.tenms.cn'
    : 'https://www.tenms.cn'
export default axios



// WEBPACK FOOTER //
// ./src/http.js